import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useState } from "react";
import { loadingState, alertMessageState } from "src/atom/LoadingState";
import { useSetRecoilState } from "recoil";
import { insertAddressDetails } from "src/services/Address/addressService";
import FieldsComponent from "./FieldsComponent";
import { fetchMilestoneInstructions } from "src/services/MainPage/GenericService";
import callApi from "src/services/Common/api";
import "src/scss/checkbox.css";

const AddressDetails = ({ data }) => {
  const enableLoader = useSetRecoilState(loadingState);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const [milestoneInst, setMilestoneInst] = useState({});
  const [formData, setFormData] = useState({});

  const [validationErrors, setValidationErrors] = useState({
    altPhoneNumber: "",
    city: "",
    cityName: "",
    landlineContact: "",
    mailingAddress: "",
    pincode: "",
    stdCode: "",
    districtId: "",
    stateId: "",
    tehsilId: "",
    corrAltPhoneNumber: "",
    corrCity: "",
    corrCityName: "",
    corrLandlineContact: "",
    corrMailingAddress: "",
    corrPincode: "",
    corrStdCode: "",
    corrDistrictId: "",
    corrStateId: "",
    corrTehsilId: "",
    officeAltPhoneNumber: "",
    officeCity: "",
    officeCityName: "",
    officeLandlineContact: "",
    officeMailingAddress: "",
    officePincode: "",
    officeStdCode: "",
    officeDistrictId: "",
    officeStateId: "",
    officeTehsilId: "",
  });

  const validateForm = () => {
    let isValid = true;
    let entryErrors = {};

    if (formData?.isCorrOtherSelected && !formData?.corrCityName) {
      entryErrors.corrCityName = "Please enter  city/village name";
      isValid = false;
    }
    if (!formData?.corrCity) {
      entryErrors.corrCity = "Please Enter Your City";
      isValid = false;
    }
    if (!formData?.corrMailingAddress) {
      entryErrors.corrMailingAddress = "Please enter your mailing address";
      isValid = false;
    }
    if (!formData?.corrPincode) {
      entryErrors.corrPincode = "Please Enter  Pincode";
      isValid = false;
    } else if (formData.corrPincode.length < 6) {
      entryErrors.corrPincode = "Pincode must be at least 6-digits long.";
      isValid = false;
    }
    if (!formData?.corrDistrictId) {
      entryErrors.corrDistrictId = "Please select District";
      isValid = false;
    }
    if (!formData?.corrStateId) {
      entryErrors.corrStateId = "Please select State";
      isValid = false;
    }
    if (!formData?.corrTehsilId) {
      entryErrors.corrTehsilId = "Please select Tehsil";
      isValid = false;
    }
    // if (!formData?.officeCity) {
    //   entryErrors.officeCity = "Please Enter your office City";
    //   isValid = false;
    // }
    // if (!formData?.officeMailingAddress) {
    //   entryErrors.officeMailingAddress = "Please enter your office mailing address";
    //   isValid = false;
    // }
    // if (!formData?.officePincode) {
    //   entryErrors.officePincode = "Please Enter Pincode";
    //   isValid = false;
    // } else if (formData.officePincode.length < 6) {
    //   entryErrors.officePincode = "Pincode must be at least 6-digits long.";
    //   isValid = false;
    // }
    // if (!formData?.officeDistrictId) {
    //   entryErrors.officeDistrictId = "Please select your office District";
    //   isValid = false;
    // }
    // if (!formData?.officeStateId) {
    //   entryErrors.officeStateId = "Please select your office State";
    //   isValid = false;
    // }
    // if (!formData?.officeTehsilId) {
    //   entryErrors.officeTehsilId = "Please select your office Tehsil";
    //   isValid = false;
    // }
    if (!formData?.sameAsCorr) {
      if (!formData?.city) {
        entryErrors.city = "Please Enter Your City";
        isValid = false;
      }
      if (formData?.isOtherSelected && !formData?.cityName) {
        entryErrors.cityName = "Please enter city/village name";
        isValid = false;
      }
      if (!formData?.mailingAddress) {
        entryErrors.mailingAddress = "Only .,/- special characters are allowed";
        isValid = false;
      }
      if (!formData?.pincode) {
        entryErrors.pincode = "Please Enter a Valid 6-digit Pincode";
        isValid = false;
      } else if (formData.pincode.length < 6) {
        entryErrors.pincode = "Pincode must be at least 6-digits long.";
        isValid = false;
      }
      if (!formData?.districtId) {
        entryErrors.districtId = "Please Select a District";
        isValid = false;
      }
      if (!formData?.stateId) {
        entryErrors.stateId = "Please Select a State";
        isValid = false;
      }
      if (!formData?.tehsilId) {
        entryErrors.tehsilId = "Please Select a Tehsil";
        isValid = false;
      }
    }
    setValidationErrors(entryErrors);
    console.log(entryErrors)
    return isValid;
  };

  const fetchAddressDetails = async () => {
    var addressDetails = async () => {
      enableLoader(true);
      const responseData = await callApi(
        `/v1/api/fetch/address-details/${data?.milestoneId}`,
        "GET",
        null,
        true,
        setAlertMessage
      );
      if (responseData.success != false) {
        setFormData(responseData.body);
      }
      enableLoader(false);
    };
    addressDetails();
  };

  useEffect(() => {
    fetchAddressDetails();
    fetchMilestoneInstApiCall();
  }, []);

  const handleCheckboxChange = (event) => {
    setFormData({
      ...formData,
      sameAsCorr: event.target.checked,
    });
  };

  const handleButtonClick = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      setValidationErrors({});
      enableLoader(true);
      const response = await insertAddressDetails(formData, data.milestoneId);
      if (response.success) {
        data.onChange(data.activeIndex);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
      enableLoader(false);
    }
  };

  const handleNext = async (e) => {
    e.preventDefault();
    enableLoader(true);
    data?.onChange(data?.activeIndex);
    enableLoader(false);
  };

  const fetchMilestoneInstApiCall = async () => {
    var fetchInstructions = async () => {
      enableLoader(true);
      var response = await fetchMilestoneInstructions(data?.milestoneId);
      if (response.success) {
        setMilestoneInst(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    fetchInstructions();
  };

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Address Details</span>
            {data?.showEdit && (
              <button
                className="btn btn-sm btn-light"
                onClick={() => data?.setEditMode(true)}
              >
                Edit
              </button>
            )}
          </div>
        </div>
        <div className="card-body">
          <FieldsComponent
            data={formData}
            ifCityName={formData?.corrCityName}
            setFormData={setFormData}
            type={"Correspondance"}
            validationErrors={validationErrors}
            edit={data?.canEdit}
          ></FieldsComponent>
          <div style={{ marginBottom: "10px" }}>
            <input
              type="checkbox"
              id="toggleForm"
              className="custom-checkbox"
              onChange={handleCheckboxChange}
              checked={formData?.sameAsCorr ? formData?.sameAsCorr : false}
              disabled={!data?.canEdit}
            />
            <label
              className="ms-3"
              htmlFor="toggleForm"
              style={{ fontSize: "18px" }}
            >
              <b>Permanent Address same as Present Residential Address</b>
            </label>
          </div>

          {!formData?.sameAsCorr && (
            <FieldsComponent
              data={formData}
              ifCityName={formData?.cityName}
              setFormData={setFormData}
              type={"Permanent"}
              validationErrors={validationErrors}
              edit={data?.canEdit}
            ></FieldsComponent>
          )}
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {data?.activeIndex !== 0 && data?.showBack ? (
                <button
                  type="button"
                  className="btn btn-sm btn-info text-white"
                  onClick={data?.goBack}
                >
                  Back
                </button>
              ) : (
                <div></div>
              )}
              {data?.showCancel && (
                <>
                  <div style={{ marginRight: "auto" }}>
                    {
                      <button
                        className="btn btn-sm btn-danger text-white"
                        type="button"
                        onClick={() => {
                          fetchAddressDetails();
                          data?.setEditMode(false);
                        }}
                      >
                        Cancel
                      </button>
                    }
                  </div>
                </>
              )}
              {data?.showSubmit && (
                <>
                  <div style={{ marginLeft: "auto" }}>
                    {
                      <button
                        className="btn btn-sm btn-success text-white"
                        type="button"
                        onClick={handleButtonClick}
                      >
                        Submit
                      </button>
                    }
                  </div>
                </>
              )}
              {data?.showNext && (
                <div>
                  {
                    <button
                      className="btn btn-sm btn-success text-white"
                      type="button"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  }
                </div>
              )}
            </div>
          </>
          {milestoneInst && milestoneInst.length > 0 && (
            <div className="card mt-3">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#3C4B64" }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span className="mr-auto">Instructions</span>
                </div>
              </div>
              <div className="col-sm-12">
                {Array.isArray(milestoneInst) &&
                  milestoneInst.map((inst, index) => (
                    <div className="m-3" key={index}>
                      <div
                        dangerouslySetInnerHTML={{ __html: inst.instruction }}
                      />
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
AddressDetails.propTypes = {
  onDetailsSubmit: PropTypes.string,
  nexttab: PropTypes.string,
};

export default AddressDetails;
